export function getDefaultShipFromLocation<
  Location extends { externalId: string },
>(
  locations: readonly Location[] | undefined,
  defaultLocationId: string | null | undefined,
): Location | undefined {
  return (
    locations?.find((location) => location.externalId === defaultLocationId) ??
    locations?.at(0)
  );
}
